// extracted by mini-css-extract-plugin
module.exports = {"form":"_5D1Zyfyu","text-field":"_5D1g2kuY","submit-btn":"_5D32QR7g","loader":"_5D1mGfeY"};